var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconItalic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.711914 12.9385H6.2666C6.67969 12.9385 6.96973 12.6836 6.96973 12.2705C6.96973 11.875 6.68848 11.6201 6.27539 11.6201H4.29785L6.43359 1.68848H8.40234C8.81543 1.68848 9.10547 1.43359 9.10547 1.02051C9.10547 0.625 8.82422 0.370117 8.41113 0.370117H2.83887C2.42578 0.370117 2.14453 0.625 2.14453 1.02051C2.14453 1.43359 2.43457 1.68848 2.84766 1.68848H4.80762L2.67188 11.6201H0.703125C0.290039 11.6201 0 11.875 0 12.2705C0 12.6836 0.298828 12.9385 0.711914 12.9385Z",
    fill: "#B2B2BF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconItalic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-italic.eeeaecb8cc70604b8ea60ca7cde209e4.svg";